module.exports = __webpack_public_path__ + "vue/img/icon-01.aa6a789e.png";